export type HydrogenSystemInfo = {
  tank1_temperature: number;
  tank2_temperature: number;
  tank_level_percentage: number;
  battery_charge_percentage: number;
  system_state: HydrogenSystemState;
  storage_state: HydrogenStorageState;
};

export enum HydrogenSystemState {
  DIAG = 0,
  RUNNING = 1,
  POSTRUN = 2,
  SHUTDOWN = 3
}

export enum HydrogenStorageState {
  SECU_INIT_CHECK = 0,
  OFF = 1,
  FCE_STARTUP = 2,
  FCE_RUN = 3,
  FCE_POSTRUN = 4,
  HSM_ERROR = 5
}
